import { getDomainLevel, getUrlEnvironment } from "./url";

const AUTH_TOKEN_SUFFIX = "-JWT";

export function getCookie(cookieName: string) {
  const pair = document.cookie.match(new RegExp(cookieName + "=([^;]+)"));

  return !!pair ? pair[1] : null;
}

export function getAuthToken() {
  const env = getUrlEnvironment();

  return getCookie(env + AUTH_TOKEN_SUFFIX);
}

export function setAuthToken(authToken: string) {
  const env = getUrlEnvironment();
  const exp = new Date();
  const appDomain = getDomainLevel(2);

  exp.setFullYear(exp.getFullYear() + 10);

  document.cookie = `${env + AUTH_TOKEN_SUFFIX}=${authToken}; path=/; domain=${
    env === "development" ? "localhost" : appDomain
  }; expires=${exp.toUTCString()};`;
}

export function clearAuthToken() {
  setAuthToken("");
  localStorage.clear();
}
